//Module Keys
let locales = {};

//Merge Views
import results from 'Modules/transactions/views/results/lan/es';
import dataDetails from 'Modules/transactions/.components/dataDetails/lan/es';
import requests from 'Modules/transactions/views/main/lan/es';
import transactionsDetails from 'Modules/transactions/.components/transactionsDetails/lan/es';

locales = { 
    ...locales, 
    ...results,
    ...dataDetails,
    ...requests,
    ...transactionsDetails,
    
};


export default locales;